module.exports = __webpack_public_path__ + "static/media/p508b.7883a680.jpg";